import React, { useState } from "react";
import {
  TYPES,
  PlacesProvider,
  Autocomplete,
  ElTabs
} from "@atresmedia/elections_modules_library";

import "./style.scss";
import Module from "./module";
import {
  SITES,
  MODULES_A3,
  MODULES_LASEXTA_PV,
  MODULES_LASEXTA_G,
  MODULES_ONDACERO,
  DOUBLE_MODULE,
  isLaSexta,
  isOndaCero,
  isAntena3,
  MODULE_TYPES,
  NAV
} from "./utils";

import ButtonGenerator from "./buttonGenerator";

const ModuleGenerator = ({ host, setHost }) => {
  const communities = "Galicia, País Vasco";

  const [moduleParameters, setModuleParameters] = useState({
    type: TYPES.REGIONAL,
    location: {
      ineId: "R12",
      name: "Galicia",
      typePlace: "REGION"
    },
    secondLocation: {
      ineId: "R16",
      name: "País Vasco",
      typePlace: "REGION"
    }
  });
  const [navegable, setNavegable] = useState(0);
  const [doubleModule, setDoubleModule] = useState(true);
  const [autocomple, setAutocomple] = useState("");

  const [regionAutocomple] = useState(communities);
  const [provinceAutocomple, setProvinceAutocomple] = useState({
    ineId: "R12",
    name: "Galicia",
    typePlace: "REGION"
  });
  const [townAutocomple, setTownAutocomple] = useState("");

  const [regionAutocomple2] = useState(communities);
  const [provinceAutocomple2, setProvinceAutocomple2] = useState({
    ineId: "R16",
    name: "País Vasco",
    typePlace: "REGION"
  });
  const [townAutocomple2, setTownAutocomple2] = useState("");

  const setDouble = isDouble => {
    setDoubleModule(isDouble);
    if (isDouble) {
      setModuleParameters({
        type: TYPES.REGIONAL,
        location: {
          ineId: "R12",
          name: "Galicia",
          typePlace: "REGION"
        },
        secondLocation: {
          ineId: "R16",
          name: "País Vasco",
          typePlace: "REGION"
        }
      });
      setProvinceAutocomple({
        ineId: "R12",
        name: "Galicia",
        typePlace: "REGION"
      });
    } else {
      setModuleParameters({
        type: TYPES.REGIONAL
      });
      setProvinceAutocomple("");
    }
  };

  const setLocation = (location, index) => {
    setModuleParameters({
      ...moduleParameters,
      ...(index === 0 ? { location } : { secondLocation: location })
    });
  };

  const reset = () => {
    setModuleParameters({
      type: TYPES.REGIONAL,
      location: null,
      secondLocation: null
    });
    setProvinceAutocomple("");
    setTownAutocomple("");
  };

  const { type, location, secondLocation } = moduleParameters;
  const isGalicia = location && location.ineId === "R12";

  const modulos = isAntena3(host)
    ? MODULES_A3
    : isOndaCero(host)
    ? MODULES_ONDACERO
    : isLaSexta(host)
    ? isGalicia
      ? MODULES_LASEXTA_G
      : MODULES_LASEXTA_PV
    : MODULE_TYPES;
  const modulosDobles = DOUBLE_MODULE;

  return (
    <div className="GenerateIframePage">
      <h1>Generador de módulos</h1>
      <button className="button" onClick={() => reset()}>
        Reset
      </button>

      <div className="generador-filters">
        {window.location.hostname === "localhost" && (
          <div>
            <h4>Site</h4>
            <select
              onChange={e => {
                setHost(e.target.value);
              }}
              value={host}
            >
              {SITES.map(e => (
                <option value={e} key={e}>
                  {e}
                </option>
              ))}
            </select>
          </div>
        )}
        <div>
          <h4>Navegable</h4>
          <select
            onChange={e => {
              setNavegable(e.target.value);
            }}
            value={navegable}
          >
            {NAV.map((e, i) => (
              <option value={i} key={i}>
                {e}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div>
        <h3>Tipo de módulos</h3>
        <div className="buttonsContainer">
          <button
            className={`button ${doubleModule && "current"}`}
            onClick={() => setDouble(true)}
          >
            Módulo doble
          </button>
          <button
            className={`button ${!doubleModule && "current"}`}
            onClick={() => setDouble(false)}
          >
            Módulos simples
          </button>
        </div>
      </div>

      {Array(doubleModule ? 2 : 1)
        .fill()
        .map((e, i) => (
          <div key={i} className={`bottom-space ${doubleModule && "two"}`}>
            {type && (
              <div>
                <h3>Selecciona lugar {doubleModule ? i + 1 : ""}</h3>

                <div className="row">
                  <div className="three">
                    <h4>Comunidad</h4>
                    {type === TYPES.MUNICIPAL ? (
                      <div>No disponible para este módulo</div>
                    ) : (
                      <PlacesProvider type="REGION" name={regionAutocomple}>
                        {data => {
                          if (data && data.length) {
                            return (
                              <Autocomplete
                                results={[
                                  ...data.filter(d => {
                                    return autocomple
                                      ? d.name
                                          .toLocaleLowerCase()
                                          .includes(
                                            autocomple.toLocaleLowerCase()
                                          )
                                      : d;
                                  })
                                ]}
                                onChange={value => setAutocomple(value)}
                                onSelect={select => {
                                  setLocation(select, i);
                                  i === 0
                                    ? setProvinceAutocomple(select)
                                    : setProvinceAutocomple2(select);
                                }}
                                defaultValue={
                                  doubleModule && i === 0
                                    ? "R12"
                                    : doubleModule && i === 1
                                    ? "R16"
                                    : ""
                                }
                                placeholder="Escribe una comunidad autónoma"
                                showArrow
                              />
                            );
                          } else {
                            return null;
                          }
                        }}
                      </PlacesProvider>
                    )}
                  </div>
                  <div className="three">
                    <h4>Provincia</h4>
                    <PlacesProvider
                      type="PROVINCE"
                      parentId={
                        i === 0
                          ? provinceAutocomple
                            ? provinceAutocomple.ineId
                            : regionAutocomple.ineId
                          : provinceAutocomple2
                          ? provinceAutocomple2.ineId
                          : regionAutocomple2.ineId
                      }
                    >
                      {data => {
                        return (
                          <Autocomplete
                            results={[
                              ...data.filter(d => {
                                return autocomple
                                  ? d.name
                                      .toLocaleLowerCase()
                                      .includes(autocomple.toLocaleLowerCase())
                                  : d;
                              })
                            ]}
                            onChange={value => setAutocomple(value)}
                            onSelect={select => {
                              setLocation(select, i);
                              i === 0
                                ? setTownAutocomple(select)
                                : setTownAutocomple2(select);
                            }}
                            placeholder="Escribe una provincia"
                            showArrow
                          />
                        );
                      }}
                    </PlacesProvider>
                  </div>
                  <div className="three">
                    <h4>Localidad</h4>
                    <PlacesProvider
                      type="TOWN"
                      parentId={
                        i === 0
                          ? townAutocomple
                            ? townAutocomple.ineId
                            : provinceAutocomple.id
                          : townAutocomple2
                          ? townAutocomple2.ineId
                          : provinceAutocomple2.id
                      }
                    >
                      {data => {
                        return (
                          <Autocomplete
                            results={[
                              ...data.filter(d => {
                                return autocomple
                                  ? d.name
                                      .toLocaleLowerCase()
                                      .includes(autocomple.toLocaleLowerCase())
                                  : d;
                              })
                            ]}
                            onChange={value => setAutocomple(value)}
                            onSelect={select => setLocation(select, i)}
                            placeholder="Escribe una localidad"
                            showArrow
                          />
                        );
                      }}
                    </PlacesProvider>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}

      {type && location && (
        <div>
          <h3>
            Módulos {location && location.name}
            {doubleModule && secondLocation && ` y ${secondLocation.name}`}
          </h3>
          <ElTabs
            titles={Object.values(doubleModule ? modulosDobles : modulos)}
            onChange={index => {
              if (doubleModule) {
                setDoubleModule(true);
              } else {
                setDoubleModule(false);
                setLocation(undefined, 1);
              }
            }}
          >
            {Object.keys(doubleModule ? modulosDobles : modulos).map(key => {
              if (key === "BUTTONS") {
                return (
                  <ButtonGenerator
                    key={key}
                    electionType={type}
                    parentPlace={location}
                    year="2020"
                    electionNumber="1"
                  />
                );
              }
              return (
                <Module
                  key={key}
                  navegable={navegable}
                  type={(doubleModule ? modulosDobles : modulos)[key]}
                  electionType={type}
                  electionName={type}
                  locations={
                    secondLocation ? [location, secondLocation] : [location]
                  }
                  site={host}
                />
              );
            })}
          </ElTabs>
        </div>
      )}
    </div>
  );
};

export default ModuleGenerator;
